import { SetContextLink } from '@apollo/client/link/context';

import { authorize, isNeedReAuthorize } from '@/lib/auth';

let token = '';

export const createAuthLink = () => {
  // Apollo Client 4のSetContextLinkは引数が (prevContext, operation) の順
  return new SetContextLink(async ({ headers }) => {
    if (isNeedReAuthorize(token)) {
      token = await authorize();
    }

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : null,
      },
    };
  });
};
